import type { IActionsPopperProps } from 'pages/selections/components/poppers/ActionsPopper';
import { PopperActionEnum } from 'pages/selections/utils/types';
import { PERMISSIONS_SUBJECT_ENUM } from 'redux-store/api/company-roles';

export const variantActionsPermissions: Partial<IActionsPopperProps['permissions']> = {
  [PopperActionEnum.EDIT]: {
    permissionSubject: PERMISSIONS_SUBJECT_ENUM.MANAGE_PROJECT_SELECTION_VARIANTS,
    permissionScope: 'canUpdate',
  },
  [PopperActionEnum.DELETE]: {
    permissionSubject: PERMISSIONS_SUBJECT_ENUM.MANAGE_PROJECT_SELECTION_VARIANTS,
    permissionScope: 'canDelete',
  },
};
